module.exports = __webpack_public_path__ + "static/media/about-1.5b504b61.jpg";